export default {
    ugcReports: {
        fetchFailed: '获取举报列表失败',
        empty: '暂无举报记录',
        none: '无',
        viewDetail: '查看明细',
        reasonSummaryItem: '{label} ×{count}',
        reportCount: '{count} 次举报',
        reportCountCollapse: '收起（{count} 次）',
        logsEmpty: '暂无举报明细',
        page: {
            contentTitle: '内容举报记录',
            contentDesc: '按作品/短剧 IP 聚合用户举报频次，可展开查看明细日志',
            userTitle: '用户举报记录',
            userDesc: '按被举报用户 UID 聚合，点击累计次数查看全部明细',
            commentTitle: '评论举报记录',
            commentDesc: '按评论 ID 聚合记录举报，仅做数据留存与检索',
        },
        tabs: {
            work: '作品举报记录',
            drama: '短剧 IP 举报记录',
        },
        timePreset: {
            LAST_7_DAYS: '近 7 天',
            LAST_30_DAYS: '近 30 天',
            CUSTOM: '自定义',
        },
        workKind: {
            SHORT_VIDEO: '短视频',
            DRAMA_EPISODE: '短剧单集',
        },
        search: {
            reportTime: '举报时间',
            customTime: '自定义时间',
            startDate: '开始日期',
            endDate: '结束日期',
            reportType: '举报分类原因',
            workKind: '作品归属类型',
            workId: '作品 ID',
            workName: '作品名称',
            dramaId: '短剧 ID',
            dramaName: '短剧名称',
            authorId: '作者 ID',
            authorName: '作者昵称',
            reporterId: '举报人 ID',
            reporterNickname: '举报人昵称',
            reportedUserId: '被举报人 UID',
            reportedUserNickname: '被举报人昵称',
            commentId: '评论 ID',
            commentUserId: '评论用户 UID',
            commentUserNickname: '评论用户昵称',
            belongingWorkId: '所属作品 ID',
            belongingWorkName: '所属作品名称',
        },
        columns: {
            workId: '作品 ID',
            workInfo: '作品信息',
            workKind: '归属类型',
            dramaId: '短剧 ID',
            dramaInfo: '短剧信息',
            dramaInfoIp: '短剧信息 (IP 资产)',
            episodeNo: '第 {no} 集',
            episodeCount: '集数体量',
            totalEpisodes: '全 {count} 集',
            author: '发布作者',
            producerAuthor: '出品 / 作者',
            reasonSummary: '举报原因汇总',
            reportTimeRange: '首次 / 最新举报时间',
            firstLabel: '首次: ',
            latestLabel: '最新: ',
            reportCount: '累计举报',
            dramaReportCount: '全剧累计举报',
            action: '操作',
            reportedUserAccount: '被举报用户账号信息',
            uidLabel: 'UID',
            commentId: '评论 ID',
            commentContent: '被举报的评论内容',
            commentAuthor: '评论发布者',
            belongingWork: '所属作品',
            belongingWorkWithEpisode: '{title}第 {no} 集',
            workIdLabel: '作品ID:',
        },
        logs: {
            summary: '共 {count} 条举报明细',
            userSummary: '该用户 {count} 条举报明细 (UID: {uid})',
            syncTip: '提示：数据实时同步',
            reporter: '举报人',
            reporterFallback: '举报用户',
            reporterId: '举报人 UID',
            reason: '举报原因',
            reasonDetail: '举报详情',
            reasonWithDesc: '原因：{reason} - "{desc}"',
            description: '描述',
            submittedAt: '提交时间',
        },
        contentType: {
            vulgar_content: '低俗色情',
            illegal_activity: '涉嫌违法犯罪',
            sensitive_content: '内容敏感',
            gang_gambling: '涉黑赌博',
            harm_minors: '侵害未成年人',
            infringement: '侵权投诉',
            quality_issue: '质量问题',
            other: '其他',
            dislike: '我不喜欢',
            unknown: '未知',
        },
        userType: {
            inappropriate_profile: '违规资料',
            impersonation: '冒充他人',
            cyberbullying: '网络暴力',
            pornographic_content: '传播色情资源',
            suspected_fraud: '涉嫌欺诈',
            safety_threat: '危害人身安全',
            ip_infringement: '侵权投诉',
            profile_violation: '违规资料',
            cyber_violence: '网络暴力',
            fraud: '涉嫌欺诈',
            personal_safety: '危害人身安全',
            infringement: '侵权投诉',
            other: '其他',
            unknown: '未知',
        },
    },
};
